import { gql } from "@apollo/client";

export const GET_COMMODITY = gql`
  query commodity($id: String!) {
    commodity(id: $id) {
      id
      name
      createdAt
      createdBy
      measurementUnit
      categories
      imageURL
      user {
        name
        establishment {
          name
        }
      }
      retailPrices {
        id
        price
        latest
        createdAt
        __typename
      }
      wholeSalePrices {
        id
        price
        latest
        createdAt
        __typename
      }
      __typename
    }
  }
`;

export const GET_RETAIL_HISTORY = gql`
  query commodity($id: String!) {
    commodity(id: $id) {
      retailPrices {
        id
        price
        latest
        createdAt
        __typename
      }
    }
  }
`;

export const GET_WHOLE_SALE_HISTORY = gql`
  query commodity($id: String!) {
    commodity(id: $id) {
      wholeSalePrices {
        id
        price
        latest
        createdAt
        __typename
      }
    }
  }
`;
